<template>
    <div class="navBar">
        <p style="float: left; margin-bottom: 0px">TPA41</p>
        <p style="float: right; margin-bottom: 0px">Corentin JERE | Alex LECOMTE | Vincent DOMINGUEZ</p>
    </div>
</template>

<script>
export default {
    name: "NavBar",
}
</script>

